module.exports = __webpack_public_path__ + "static/media/T14-T25-02.2934b697.svg";